import { queryOptions } from '@tanstack/react-query';
import type { BlogPost } from '@/hooks/useCommunity';
import { restGet } from './supabaseRest';

export type BlogSummary = Omit<BlogPost, 'content'>;

export function blogPostsQueryOptions() {
  return queryOptions({
    queryKey: ['blog-posts', 'summaries'],
    queryFn: async () => {
      const rows = await restGet<BlogSummary[]>('blog_posts?select=id,title,slug,excerpt,cover_image,category,tags,author,published_at&order=published_at.desc');
      if (!rows) throw new Error('The blog could not be loaded. Please try again.');
      return rows;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export function blogPostQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ['blog-post', slug],
    queryFn: async () => {
      const rows = await restGet<BlogPost[]>(`blog_posts?select=id,title,slug,excerpt,content,cover_image,category,tags,author,published_at&slug=eq.${encodeURIComponent(slug)}&limit=1`);
      if (!rows) throw new Error('The article could not be loaded. Please try again.');
      return rows[0] ?? null;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}